export const THDMenuItemStyles = {
    root: {
        fontSize: '16px',
        fontFamily: 'helvetica-neue,Helvetica Neue,Helvetica,Arial,sans-serif',
        paddingRight: 24,
        paddingLeft: 24,
        minHeight: '25px',
        marginBottom: '25px',
        paddingBottom: 0,
        paddingTop: 0,
        lineHeight: '24px',
        '&:hover': {
            backgroundColor: '#E1E1E1',
        },
        '&:first-child': {
            marginTop: '15px',
        },
        '&:last-child': {
            marginBottom: '15px',
        },
        '&$selected': {
            backgroundColor: '#E1E1E1',
        },
    },
};
